import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs",
  href: "/login",
  alt: "Contact Me",
  title: ""
}
const _hoisted_2 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_3 = { class: "flex items-center justify-center min-h-full p-4 text-center sm:p-0" }
const _hoisted_4 = { class: "absolute top-0 right-0 z-40 block pt-4 pr-4" }
const _hoisted_5 = { class: "flex items-center justify-center w-12 h-12 mx-auto bg-green-100 rounded-full" }
const _hoisted_6 = {
  key: 0,
  class: "mt-3 text-center sm:mt-5"
}
const _hoisted_7 = {
  key: 0,
  class: "mt-3 text-center sm:mt-5"
}
const _hoisted_8 = {
  key: 0,
  class: "mt-2 text-left"
}
const _hoisted_9 = { class: "text-sm text-clay-800" }
const _hoisted_10 = { class: "my-6 text-sm text-clay-800" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "text-sm text-clay-800" }
const _hoisted_13 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_14 = {
  key: 2,
  class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 1,
  class: "mt-3 text-center sm:mt-5"
}
const _hoisted_20 = {
  key: 1,
  class: "mt-3 text-center sm:mt-5"
}

import {ref} from 'vue';
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {ChatBubbleBottomCenterIcon} from '@heroicons/vue/24/outline';
import {client} from "@/shared";
import {MessageMeRequest} from "@/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageMe',
  props: {
    talentDisplayName: String,
    talentProfileUrl: String,
    memberProfileUrl: String,
    memberDisplayName: String,
    memberEmail: String,
    isMessagingEnabled:Boolean,
    memberIsPro:Boolean
},
  setup(__props) {

// @ts-ignore
const props = __props;


const isOpen = ref(false)
const openConfirmation = async () => {
    isOpen.value = true;
}

const closeConfirmation = async () => {
    isOpen.value = false;
}

let processing = ref(false);
let isMessageSent = ref(false);
const submit = async () => {
    processing.value = true;
    await client.post(new MessageMeRequest({profileUrl: props.talentProfileUrl}))
        .then(_ => {
            processing.value = false;
            isMessageSent.value = true;
        });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.memberEmail)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs",
          type: "button",
          onClick: openConfirmation,
          alt: "Contact Me",
          title: ""
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            class: "w-5 h-5 shrink-0 fill-electric-50 group-hover:fill-electric-500"
          }, [
            _createElementVNode("path", {
              class: "fa-secondary",
              opacity: ".4",
              d: "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 238.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z"
            }),
            _createElementVNode("path", {
              class: "fa-primary",
              d: "M224 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184.4 240c-8.8-9.9-24-10.7-33.9-1.9s-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32z"
            })
          ], -1),
          _createElementVNode("span", { class: "ml-4" }, "Contact Me", -1)
        ])))
      : (_openBlock(), _createElementBlock("a", _hoisted_1, _cache[2] || (_cache[2] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            class: "w-5 h-5 shrink-0 fill-electric-50 group-hover:fill-electric-500"
          }, [
            _createElementVNode("path", {
              class: "fa-secondary",
              opacity: ".4",
              d: "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 238.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z"
            }),
            _createElementVNode("path", {
              class: "fa-primary",
              d: "M224 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184.4 240c-8.8-9.9-24-10.7-33.9-1.9s-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32z"
            })
          ], -1),
          _createElementVNode("span", { class: "ml-4" }, "Contact Me", -1)
        ]))),
    _createVNode(_unref(TransitionRoot), {
      show: isOpen.value,
      as: "template"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-40",
          onClose: closeConfirmation
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" }, null, -1)
              ])),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:max-w-lg sm:w-full sm:p-6" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("button", {
                            class: "text-gray-400 bg-white rounded-md hover:text-gray-600 focus:outline-hidden",
                            type: "button",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = false))
                          }, _cache[4] || (_cache[4] = [
                            _createElementVNode("span", { class: "sr-only" }, "Close", -1),
                            _createElementVNode("svg", {
                              class: "w-6 h-6",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                              viewBox: "0 0 24 24",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                d: "M6 18L18 6M6 6l12 12",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ], -1)
                          ]))
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_unref(ChatBubbleBottomCenterIcon), {
                              "aria-hidden": "true",
                              class: "w-6 h-6 text-green-600"
                            })
                          ]),
                          (__props.memberIsPro)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                (__props.isMessagingEnabled)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                      _createVNode(_unref(DialogTitle), {
                                        as: "h3",
                                        class: "mb-6 text-lg font-medium leading-6 text-gray-900"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Ask " + _toDisplayString(__props.talentDisplayName) + " to get in touch with you! ", 1)
                                        ]),
                                        _: 1
                                      }),
                                      (!_unref(isMessageSent))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createElementVNode("p", _hoisted_9, [
                                              _createElementVNode("strong", null, "We'll send " + _toDisplayString(__props.talentDisplayName) + " the following message:", 1)
                                            ]),
                                            _createElementVNode("p", _hoisted_10, [
                                              _cache[5] || (_cache[5] = _createTextVNode(" Hello ")),
                                              _createElementVNode("em", null, _toDisplayString(__props.talentDisplayName), 1),
                                              _cache[6] || (_cache[6] = _createTextVNode(",")),
                                              _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                              _cache[8] || (_cache[8] = _createTextVNode(" I found your profile on StageAgent.com and would like to talk with you about a potential performing or networking opportunity. You can view my StageAgent profile ")),
                                              _createElementVNode("a", {
                                                href: `/talent/${__props.memberProfileUrl}`,
                                                class: "underline",
                                                target: "_blank"
                                              }, "here", 8, _hoisted_11),
                                              _cache[9] || (_cache[9] = _createTextVNode(". If you are interested in talking with me, please contact me at the email address below: "))
                                            ]),
                                            _createElementVNode("p", _hoisted_12, [
                                              _cache[10] || (_cache[10] = _createTextVNode(" Best,")),
                                              _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                                              _createTextVNode(" " + _toDisplayString(__props.memberDisplayName), 1),
                                              _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                                              _createTextVNode(" " + _toDisplayString(__props.memberEmail), 1)
                                            ])
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[13] || (_cache[13] = [
                                            _createElementVNode("p", null, "Your message was successfully sent.", -1)
                                          ]))),
                                      (!_unref(isMessageSent))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            _createElementVNode("button", {
                                              disabled: _unref(processing),
                                              class: "inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-electric-600 hover:bg-electric-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:col-start-2 sm:text-sm",
                                              type: "button",
                                              onClick: submit
                                            }, [
                                              (_unref(processing))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Sending..."))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_17, "Send"))
                                            ], 8, _hoisted_15),
                                            _createElementVNode("button", {
                                              ref: "cancelButtonRef",
                                              disabled: _unref(processing),
                                              class: "inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-clay-500 rounded-md shadow-sm hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                                              type: "button",
                                              onClick: closeConfirmation
                                            }, "Cancel ", 8, _hoisted_18)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _createVNode(_unref(DialogTitle), {
                                        as: "h3",
                                        class: "mb-6 text-lg font-medium leading-6 text-gray-900"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(__props.talentDisplayName) + " has disabled messaging! ", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createVNode(_unref(DialogTitle), {
                                  as: "h3",
                                  class: "mb-6 text-lg font-medium leading-6 text-gray-900"
                                }, {
                                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                                    _createElementVNode("span", null, [
                                      _createTextVNode("Please "),
                                      _createElementVNode("a", {
                                        href: "/account-settings/membership/upgrade",
                                        class: "text-clay-500 underline"
                                      }, "upgrade"),
                                      _createTextVNode(" to a pro account to send an email message!")
                                    ], -1)
                                  ])),
                                  _: 1
                                })
                              ]))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})